// extracted by mini-css-extract-plugin
export default {"backgroundImage":"BackgroundImage_backgroundImage__TYek5"};